import { render, staticRenderFns } from "./statusApproval.vue?vue&type=template&id=2ef3553b"
import script from "./statusApproval.vue?vue&type=script&lang=js"
export * from "./statusApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports